export const AltoTechLogo = ({ className = "", size = 64 }: { className?: string; size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M49.9503 45.8831L37.0044 15.4464C36.8289 15.0335 36.4943 14.707 36.0814 14.5127C35.8142 14.3885 35.5119 14.3184 35.1989 14.3184H28.9162C28.6031 14.3184 28.3035 14.3885 28.0391 14.5127C28.0418 14.5235 28.0445 14.537 28.0499 14.5478L32.0602 23.9772L40.7745 44.469C40.9715 44.9332 41.4007 45.2543 41.9026 45.3191C44.5339 45.6564 46.9952 46.126 49.2325 46.7062C49.7236 46.8331 50.1474 46.3473 49.9503 45.8831Z"
      fill="url(#paint0_linear_152_3688)"
    />
    <path
      d="M35.2016 14.3184H28.9162C28.6031 14.3184 28.3035 14.3885 28.0391 14.51C28.0418 14.5208 28.0445 14.5343 28.0499 14.5451L32.0602 23.9476L36.0841 14.5127C35.8142 14.3885 35.5146 14.3184 35.2016 14.3184Z"
      fill="#212529"
    />
    <path
      d="M35.2021 14.3184H28.9166C28.6036 14.3184 28.304 14.3885 28.0395 14.51C27.6239 14.7016 27.2893 15.0281 27.1112 15.441L14.0356 46.0936C13.8926 46.431 14.203 46.7845 14.5592 46.69C16.9098 46.0639 19.5168 45.562 22.3101 45.2111C22.7527 45.1545 23.1332 44.8684 23.3086 44.4609L32.0607 23.9449L36.0846 14.51C35.8147 14.3885 35.5151 14.3184 35.2021 14.3184Z"
      fill="url(#paint1_radial_152_3688)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_152_3688"
        x1="30.8281"
        y1="18.5102"
        x2="48.8557"
        y2="44.0977"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBED22" />
        <stop offset="1" stopColor="#37B44A" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_152_3688"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.4997 15.9311) scale(38.0123 37.6136)"
      >
        <stop stopColor="#28AAE1" />
        <stop offset="0.2881" stopColor="#209ED9" />
        <stop offset="0.8064" stopColor="#097FC4" />
        <stop offset="1" stopColor="#0071BB" />
      </radialGradient>
    </defs>
  </svg>
);